import React from 'react';
import { arrayOf, func, number, shape, string, object } from 'prop-types';
import { noop, without } from 'lodash';
import { Carousel } from '@fiverr-private/orca';
import { FILTER_CAROUSEL_TILE } from './Tile/constants';
import Tile from './Tile';

const FilterCarousel = ({
    slides = [],
    className = '',
    onChange = noop,
    selected = [],
    breakpoints,
    slidesToShow,
    maxElements,
}) => {
    const carouselInactive = maxElements && selected.length >= maxElements;
    const toggleSlide = (slug) => {
        if (selected.includes(slug)) {
            onChange(without(selected, slug));
            return;
        }
        if (carouselInactive) {
            return;
        }
        onChange([...selected, slug]);
    };

    return (
        <Carousel
            carouselClassName={className}
            breakpoints={breakpoints}
            slides={slides}
            Component={Tile}
            slidesToShow={slidesToShow}
            componentProps={{
                onClick: toggleSlide,
                selected,
                disabled: carouselInactive,
            }}
        />
    );
};

FilterCarousel.propTypes = {
    className: string,
    slides: arrayOf(shape(FILTER_CAROUSEL_TILE)),
    onChange: func,
    selected: arrayOf(string),
    breakpoints: object,
    maxElements: number,
    slidesToShow: number,
};

export default FilterCarousel;
